import currentTimeZone from '../enum/timeZone';
import i18n from '../i18n';

/**
 * Convert UTC string to local date & time
 * @param {any} utcString utc string
 * @returns {string} formatted local date time
 */
function ConvertUTCtoDateTime(utcString: string): string {
  if (!utcString) {
    return '';
  }

  const date = new Date(utcString);

  if (Number.isNaN(date.getTime())) {
    return '';
  }

  const options: Intl.DateTimeFormatOptions = {
    timeZone: currentTimeZone,

    year: 'numeric',
    month: '2-digit',
    day: '2-digit',

    hour: '2-digit',
    minute: '2-digit',

    hour12: true,
  };

  try {
    return new Intl.DateTimeFormat(i18n.language, options).format(date);
  } catch (error) {
    console.error('Error formatting date:', error);
    return '';
  }
}

export default ConvertUTCtoDateTime;
